import React from "react";
import { Box, Button, Flex, SimpleGrid } from "@chakra-ui/react";
import { useUser } from "context/user";
import ProfileText, { Variant } from "./ProfileText";
import { ReactComponent as RocketImage } from "assets/rocket.svg";

interface ProfileInformationProps {
  callback: () => void;
}

const ProfileInformation: React.FC<ProfileInformationProps> = ({
  callback
}: ProfileInformationProps) => {
  const { user } = useUser()!;

  return (
    <Flex direction={["column", "row"]} justifyContent="space-between">
      <Flex
        flexGrow={1}
        direction="column"
        alignItems={["flex-start", "center"]}
      >
        <SimpleGrid w="full" columns={[1, 3]} gap={8}>
          <ProfileText
            label="First Name"
            text={user.first_name}
            variant={Variant.SMALL}
          />
          <ProfileText
            label="Last Name"
            text={user.last_name}
            variant={Variant.SMALL}
          />
          <ProfileText
            label="Username"
            text={user.username}
            variant={Variant.SMALL}
          />
          <ProfileText
            label="Email"
            text={user.email}
            variant={Variant.SMALL}
          />
        </SimpleGrid>
        <Button onClick={callback} mt={8} variant="blue" size="md">
          Edit Profile
        </Button>
      </Flex>
      <Box width="224px" mt={[10, 0]}>
        <RocketImage width="100%" />
      </Box>
    </Flex>
  );
};

export default ProfileInformation;
